module.exports = __webpack_public_path__ + "static/media/author-Esme.c748e634.png";


//////////////////
// WEBPACK FOOTER
// ./public/maxsizeimages/authorSpotlight/author-Esme.png
// module id = 1665
// module chunks = 1